import { isNumber } from "@/utils/variable-evaluation";

const MAX_PORTRAIT_ASPECT_RATIO = 4 / 5;
const MAX_LANDSCAPE_ASPECT_RATIO = 5 / 4;

export function getMaxAspectHeight(
  width: number,
  height: number,
  wrapperWidth: number
) {
  if (
    !isNumber(wrapperWidth) ||
    !Number.isFinite(wrapperWidth) ||
    wrapperWidth <= 0
  ) {
    return "auto";
  }

  if (
    !isNumber(width) ||
    !Number.isFinite(width) ||
    width <= 0 ||
    !isNumber(height) ||
    !Number.isFinite(height) ||
    height <= 0
  ) {
    return wrapperWidth / MAX_LANDSCAPE_ASPECT_RATIO;
  }

  let aspectRatio = width / height;

  if (aspectRatio < MAX_PORTRAIT_ASPECT_RATIO) {
    aspectRatio = MAX_PORTRAIT_ASPECT_RATIO;
  } else if (aspectRatio > MAX_LANDSCAPE_ASPECT_RATIO) {
    aspectRatio = MAX_LANDSCAPE_ASPECT_RATIO;
  }

  return (1 / aspectRatio) * wrapperWidth;
}
